module.exports = __webpack_public_path__ + "img/arrow-down-fill.d9f97bb8.svg";